import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { useRouter } from 'next/router';
import axiosConfig from '../../../store/sagas/axiosConfig';
import { SearchStatus } from '../../../constants';
import {
  loginSuccess, logout, setLoaded, getTravelAgencySettingsRequest,
} from '../../../store/slices/user';

const Auth0ProvidedElement = ({ children }) => {
  const {
    user, getAccessTokenSilently, isLoading, isAuthenticated,
  } = useAuth0();

  const router = useRouter();
  const { travelAgencyAliasName } = router.query;
  const { travelAgencySearchStatus } = useSelector((store) => store.user);

  const dispatch = useDispatch();

  useEffect(() => {
    if (travelAgencySearchStatus === SearchStatus.INITIAL) {
      dispatch(getTravelAgencySettingsRequest({ isLoading }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (isLoading || travelAgencySearchStatus === SearchStatus.SEARCHING) {
          return;
        }

        if (isAuthenticated) {
          const token = await getAccessTokenSilently();
          axiosConfig.defaults.headers.Authorization = `Bearer ${token}`;
          axiosConfig.defaults.params = axiosConfig.defaults.params || {};
          dispatch(
            loginSuccess({
              token,
              email: user.email,
              defaultCity: user.defaultCity,
              name: user.name,
              user,
            }),
          );
        } else {
          dispatch(logout());
          if (travelAgencyAliasName) {
            axiosConfig.defaults.params = {
              ...axiosConfig.defaults.params,
              travelAgencyAliasName,
            };
          }
        }
      } catch (e) {
        dispatch(setLoaded());
      }
    })();
  }, [dispatch, user, isLoading, getAccessTokenSilently, isAuthenticated,
    travelAgencySearchStatus, travelAgencyAliasName]);

  return children || <></>;
};

Auth0ProvidedElement.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth0ProvidedElement;
